import type { FC, PropsWithChildren } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '~/shared/lib/queryClient'

/**
 * ApiProvider shares the application's singleton QueryClient with child components. Children may
 * access the client's capabilities with the useQuery and useMutation hooks in ~/shared/hooks/query.
 *
 * This provider is an alternative to using Redux as a shared cache for API data, without the
 * overhead of boilerplate actions and reducers for common API operations.
 */
export const ApiProvider: FC<PropsWithChildren> = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
)
